import { Type } from 'class-transformer';
import { CashReceiptAttachmentResultDto } from './cash-receipt-attachment-result-dto';
import { CashReceiptItemResultDto } from './cash-receipt-item-result-dto';
import { CashReceiptResultDto } from './cash-receipt-result-dto';

export class CashReceiptDetailResultDto extends CashReceiptResultDto {
    @Type(() => CashReceiptItemResultDto)
    items: CashReceiptItemResultDto[];

    @Type(() => CashReceiptAttachmentResultDto)
    attachments: CashReceiptAttachmentResultDto[];
}
